import SettingsVaultModule from './settings-vault.module'

export default SettingsVaultModule
